import { ConnectionsProfile } from '../../api/expert/types';
import { ConversationMessage, ConversationStatus } from '../../api/messaging/types';

export const getFullName = (firstName: string, lastName: string, title?: string) => {
    return `${title ? title + ' ' : ''} ${firstName} ${lastName}`;
};

export const getOtherParticipant = (convo: ConversationStatus, currentUserId: string) => {
    const otherParticipant = convo.participants.find((participant) => participant.userId !== currentUserId);

    if (otherParticipant) {
        return otherParticipant.userId;
    } else {
        return undefined;
    }
};

export const getOtherParticipantObject = (participants: ConnectionsProfile[], currentExpertId: string) => {
    return participants.find((participant) => participant.expertId !== currentExpertId);
};

export const getFirstAttachmentFileName = (message: ConversationMessage) => {
    if (message.attachments?.length > 0) {
        const firstAttachment = message.attachments[0];
        return firstAttachment.fileDisplayName;
    }
    return undefined;
};
